import { PhoneIcon, EnvelopeIcon, MapPinIcon } from '@heroicons/react/24/outline';

export default function ContactUsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-gray-100 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-4xl font-semibold text-gray-800 mb-8">Contact Us</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Phone */}
          <div className="bg-white shadow rounded-2xl p-6 flex flex-col items-center text-center">
            <PhoneIcon className="h-8 w-8 text-blue-500 mb-2" />
            <h3 className="text-lg font-medium text-gray-800">Phone</h3>
            <p className="mt-2 text-gray-600">0151 546 3574</p>
          </div>

          {/* Email */}
          <div className="bg-white shadow rounded-2xl p-6 flex flex-col items-center text-center">
            <EnvelopeIcon className="h-8 w-8 text-blue-500 mb-2" />
            <h3 className="text-lg font-medium text-gray-800">Email</h3>
            <p className="mt-2 text-gray-600">olqom@rcaol.org.uk</p>
          </div>

          {/* Location */}
          <div className="bg-white shadow rounded-2xl p-6 flex flex-col items-center text-center">
            <MapPinIcon className="h-8 w-8 text-blue-500 mb-2" />
            <h3 className="text-lg font-medium text-gray-800">Where to find us</h3>
            <p className="mt-2 text-gray-600">Stonebridge Lane, Croxteth, Liverpool, L11 9AZ</p>
          </div>
        </div>

        {/* Optional Map Section */}
        <div className="mt-12">
          <iframe
            title="Google Map"
            className="w-full rounded-2xl shadow h-64"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2375.9107379250413!2d-2.9070848240811262!3d53.452181872320075!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b2205f335794b%3A0x2c8b7d4f34f3b4ca!2sOur%20Lady%20Queen%20of%20Martyrs%20Catholic%20Church!5e0!3m2!1sen!2suk!4v1749032565239!5m2!1sen!2suk"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>

        <div>
          <h2 className="text-xl font-bold text-center my-6">Safe Guarding</h2>
          <p className="text-center text-black mb-6">
            Please follow the link below to access the Archdiocese of Liverpool safeguarding information
          </p>
          <div className="text-center">
            <a
              href="https://www.liverpoolcatholic.org.uk/department/safeguarding"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              Visit Safeguarding Page
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
